import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import LocaleIcon from '@material-ui/icons/Language'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputAdornment from '@material-ui/core/InputAdornment'
import CircularProgress from '@material-ui/core/CircularProgress'
import Tooltip from '@material-ui/core/Tooltip'

const Wrap = styled.div.attrs({
  className: 'tr-locale-switcher'
})`
  .locale-icon {
      font-size: 1.1rem;
  }
`

export class LocaleSwitcher extends PureComponent
{
  static propTypes = {
    value: PropTypes.shape({
      id: PropTypes.string,
      locale: PropTypes.string
    }).isRequired,
    locales: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        locale: PropTypes.string
      })
    ).isRequired,
    onLocaleChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    selectProps: PropTypes.object,
    tooltipProps: PropTypes.object
  }

  static defaultProps = {
    selectProps: {},
    loading: false,
    locales: []
  }

  onChange = event => {
    const { locales, onLocaleChange } = this.props
    onLocaleChange(
      locales.find( locale => locale.id === event.target.value)
    )
  }

  render()
  {
    const { value, selectProps, loading, tooltipProps, locales } = this.props
    if(!value || !locales) return null

    return (
      <Wrap>
      <Select
        value={value.id}
        onChange={this.onChange}
        disableUnderline
        style={{
          fontSize: '0.8rem'
        }}
        startAdornment={(
          <InputAdornment position='start'>
            {loading && <CircularProgress size={15} className='locale-icon'/>}
            {!loading && !tooltipProps && <LocaleIcon className='locale-icon'/> }
            {!loading && tooltipProps && (
              <Tooltip {...tooltipProps}>
                <LocaleIcon className='locale-icon'/>
              </Tooltip>
            )}
          </InputAdornment>
        )}
        {...selectProps}
      >
        { locales.map( ({id, locale}) => (
          <MenuItem key={id} value={id}>{locale}</MenuItem>
        ))}
      </Select>
      </Wrap>
    )
  }
}


// WEBPACK FOOTER //
// ../../src/LocaleSwitcher/LocaleSwitcher.js